export const styles = {
	container: {
		width: '100%',
		maxWidth: '1300px',
		margin: '0 auto',
		padding: '0.5px',
		//background: 'linear-gradient(135deg, #f8fafc 0%, #e3eafc 100%)',
		minHeight: '100vh',
		fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
	},
	header: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginBottom: '2rem',
		flexWrap: 'wrap',
		gap: '1rem',
	},
	headerLeft: {
		display: 'flex',
		alignItems: 'center',
		gap: '1rem',
	},
	headerRight: {
		display: 'flex',
		gap: '1rem',
	},
	title: {
		fontSize: '2rem',
		fontWeight: '800',
		color: '#1e293b',
		margin: 0,
		background: 'linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)',
		WebkitBackgroundClip: 'text',
		WebkitTextFillColor: 'transparent',
	},
	analyticsBtn: {
		border: '2px solid #e2e8f0',
		borderRadius: '10px',
		padding: '0.6rem 1.2rem',
		fontSize: '0.9rem',
		fontWeight: '600',
		cursor: 'pointer',
		display: 'flex',
		alignItems: 'center',
		gap: '0.5rem',
		transition: 'all 0.3s ease',
	},
	createBtn: {
		background: 'linear-gradient(135deg, #2563eb 0%, #3b82f6 100%)',
		color: '#fff',
		border: 'none',
		borderRadius: '10px',
		padding: '0.8rem 2rem',
		fontSize: '1rem',
		fontWeight: '700',
		cursor: 'pointer',
		boxShadow: '0 4px 20px rgba(37, 99, 235, 0.3)',
		transition: 'all 0.3s ease',
	},
	backBtn: {
		background: '#fff',
		color: '#2563eb',
		border: '2px solid #2563eb',
		borderRadius: '10px',
		padding: '0.8rem 1.5rem',
		fontSize: '1rem',
		fontWeight: '600',
		cursor: 'pointer',
		display: 'flex',
		alignItems: 'center',
		gap: '0.5rem',
		transition: 'all 0.3s ease',
	},
	analytics: {
		background: '#fff',
		borderRadius: '20px',
		padding: '2rem',
		marginBottom: '2rem',
		boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
	},
	statsGrid: {
		display: 'grid',
		gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
		gap: '1.5rem',
		marginBottom: '2rem',
	},
	statCard: {
		background: 'linear-gradient(135deg, #f8fafc 0%, #fff 100%)',
		borderRadius: '16px',
		padding: '1.5rem',
		display: 'flex',
		alignItems: 'center',
		gap: '1rem',
		border: '2px solid #e2e8f0',
		transition: 'transform 0.3s ease',
	},
	statIcon: {
		borderRadius: '12px',
		padding: '1rem',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	statContent: {
		flex: 1,
	},
	statValue: {
		fontSize: '2rem',
		fontWeight: '800',
		color: '#1e293b',
	},
	statLabel: {
		fontSize: '0.9rem',
		color: '#64748b',
		fontWeight: '500',
	},
	chartContainer: {
		background: 'linear-gradient(135deg, #f8fafc 0%, #fff 100%)',
		borderRadius: '16px',
		padding: '2rem',
		border: '2px solid #e2e8f0',
	},
	chartTitle: {
		fontSize: '1.2rem',
		fontWeight: '700',
		color: '#1e293b',
		marginBottom: '1.5rem',
		marginTop: 0,
	},
	chart: {
		display: 'flex',
		flexDirection: 'column',
		gap: '1rem',
	},
	chartRow: {
		display: 'grid',
		gridTemplateColumns: '200px 1fr 60px',
		alignItems: 'center',
		gap: '1rem',
	},
	chartLabel: {
		display: 'flex',
		alignItems: 'center',
		gap: '0.5rem',
		fontSize: '0.9rem',
		fontWeight: '600',
		color: '#475569',
	},
	chartBarContainer: {
		background: '#f1f5f9',
		borderRadius: '20px',
		height: '28px',
		overflow: 'hidden',
		position: 'relative',
	},
	chartBar: {
		height: '100%',
		borderRadius: '20px',
		transition: 'width 1s ease',
	},
	chartValue: {
		fontSize: '0.9rem',
		fontWeight: '700',
		color: '#1e293b',
		textAlign: 'right',
	},
	gridContainer: {
		width: '100%',
	},
	grid: {
		display: 'grid',
		gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
		gap: '1.5rem',
		marginBottom: '2rem',
	},
	card: {
		background: '#ffffff',
		borderRadius: '1.25rem',
		boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
		padding: '2rem',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		position: 'relative',
		cursor: 'pointer',
		border: '3px solid transparent',
		transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
		minHeight: '220px',
		textAlign: 'center',
		wordBreak: 'break-word',
		overflowWrap: 'anywhere',
		overflow: 'hidden',
		minWidth: 0,
		maxWidth: '100%',
		boxSizing: 'border-box',
	},
	cardSelected: {
		border: '3px solid #2563eb',
		background: 'linear-gradient(135deg, #ffffff 0%, #eff6ff 100%)',
	},
	cardActions: {
		position: 'absolute',
		top: '1rem',
		right: '1rem',
		display: 'flex',
		gap: '0.5rem',
		transition: 'opacity 0.3s ease',
	},
	actionBtn: {
		background: '#f1f5f9',
		border: 'none',
		borderRadius: '8px',
		padding: '0.5rem',
		color: '#64748b',
		cursor: 'pointer',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		transition: 'all 0.2s ease',
	},
	cardIcon: {
		marginBottom: '1rem',
		transition: 'transform 0.3s ease',
	},
	cardTitle: {
		fontSize: '1.2rem',
		fontWeight: '700',
		color: '#1e293b',
		marginBottom: '0.5rem',
		wordBreak: 'break-word',
		overflowWrap: 'anywhere',
		wordWrap: 'break-word',
		minWidth: 0,
		maxWidth: '100%',
	},
	cardDesc: {
		color: '#64748b',
		fontSize: '0.9rem',
		lineHeight: '1.5',
		marginBottom: '1rem',
	},
	usageBadge: {
		borderRadius: '20px',
		padding: '0.5rem 1rem',
		fontSize: '0.85rem',
		fontWeight: '600',
		display: 'flex',
		alignItems: 'center',
		gap: '0.4rem',
		marginTop: 'auto',
		transition: 'all 0.3s ease',
	},
	error: {
		background: '#fee2e2',
		color: '#dc2626',
		border: '2px solid #fca5a5',
		padding: '1rem 1.5rem',
		borderRadius: '12px',
		marginTop: '1rem',
		fontWeight: '600',
	},
	modalOverlay: {
		position: 'fixed',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		background: 'rgba(0, 0, 0, 0.6)',
		backdropFilter: 'blur(6px)',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		zIndex: 1000,
		padding: '1rem',
	},
	modal: {
		background: '#fff',
		borderRadius: '18px',
		boxShadow: '0 25px 50px rgba(0, 0, 0, 0.3)',
		width: '100%',
		maxWidth: '760px',
		maxHeight: '92vh',
		overflow: 'hidden',
		display: 'flex',
		flexDirection: 'column',
	},
	modalHeader: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		padding: '1.25rem 1.5rem',
		borderBottom: '1px solid #e2e8f0',
	},
	modalHeaderLeft: {
		display: 'flex',
		alignItems: 'center',
		gap: '0.75rem',
		minWidth: 0,
		flex: 1,
	},
	modalTitle: {
		fontSize: '1.35rem',
		fontWeight: '700',
		color: '#1e293b',
		lineHeight: 1.25,
		wordBreak: 'break-word',
	},
	modalClose: {
		background: 'transparent',
		border: 'none',
		fontSize: '2.5rem',
		color: '#94a3b8',
		cursor: 'pointer',
		width: '44px',
		height: '44px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		borderRadius: '10px',
		transition: 'all 0.2s ease',
		lineHeight: 1,
	},
	modalContent: {
		padding: '1.5rem',
		flex: 1,
		overflowY: 'auto',
		color: '#1e293b',
		lineHeight: '1.7',
	},
	textarea: {
		width: '100%',
		padding: '1rem',
		borderRadius: '12px',
		border: '2px solid #e2e8f0',
		fontSize: '1rem',
		fontFamily: 'inherit',
		resize: 'vertical',
		minHeight: '200px',
		outline: 'none',
	},
	modalActions: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: '1rem',
		padding: '1.25rem 1.5rem',
		borderTop: '1px solid #e2e8f0',
		boxSizing: 'border-box',
	},
	saveBtn: {
		flex: 1,
		padding: '0.9rem',
		background: '#10b981',
		color: '#fff',
		border: 'none',
		borderRadius: '12px',
		fontSize: '1rem',
		fontWeight: '700',
		cursor: 'pointer',
		transition: 'all 0.3s ease',
	},
	cancelBtn: {
		flex: 1,
		padding: '0.9rem',
		background: '#ef4444',
		color: '#fff',
		border: 'none',
		borderRadius: '12px',
		fontSize: '1rem',
		fontWeight: '700',
		cursor: 'pointer',
		transition: 'all 0.3s ease',
	},
	editBtn: {
		margin: 0,
		flex: 1,
		minWidth: '220px',
		padding: '0.9rem 2rem',
		background: '#2563eb',
		color: '#fff',
		border: 'none',
		borderRadius: '12px',
		fontSize: '1rem',
		fontWeight: '700',
		cursor: 'pointer',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		gap: '0.6rem',
		transition: 'all 0.3s ease',
	},
};

